module.exports = __webpack_public_path__ + "05_face.01cb3cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/05_face.png
// module id = iU3p
// module chunks = 0